var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section-title section-title_app"},[_c('h3',[_vm._v("Generar corte de caja")])])])
}]

export { render, staticRenderFns }